import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import qr_code from './qr_code.png';
import { BASE_URL } from "./Constants.js";

const Qr_Code = () => {
  const { id } = useParams();
  const [utrNumber, setUtrNumber] = useState('');
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}updateqrpayment`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id, utr_number: utrNumber })
      });

      if (!response.ok) throw new Error('Failed to update payment');
      setSubmitMessage('✅ UTR submitted successfully!');
    } catch (error) {
      console.error(error);
      setSubmitMessage('❌ Error submitting UTR.');
    }
  };

  const handlePayNow = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}initiate_payment`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_id: "testing-order-one",
          amount: "10.00",
          customer_id: "testing-customer-one",
          customer_email: "test@mail.com",
          customer_phone: "8604613494",
          payment_page_client_id: "hdfcmaster",
          first_name: "John",
          last_name: "Wick",
          currency: "INR",
          return_url: "https://shop.merchant.com",
          description: "Complete your payment"
        })
      });

      const data = await response.json();
      if (response.ok && data.payment_url) {
        window.location.href = data.payment_url;
      } else {
        alert('Failed to get payment URL');
      }
    } catch (error) {
      console.error('Error initiating payment:', error);
      alert('Something went wrong while initiating payment.');
    }
  };

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar />
      <div className="page-container">
        <Header />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <div className="card shadow p-4">
                    <div className="text-center">
                      <h2 className="mb-3">Scan & Pay</h2>
                      <img src={qr_code} alt="QR Code" className="img-fluid mb-3" style={{ maxWidth: "300px" }} />
                      <p>Scan the QR code above to pay via UPI or use the form below.</p>
                    </div>

                    {/* Pay Now Form */}
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="row g-3">
                        <div className="col-md-6">
                          <label className="form-label">First Name</label>
                          <input type="text" className="form-control" defaultValue="John" required />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Last Name</label>
                          <input type="text" className="form-control" defaultValue="Wick" required />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Email</label>
                          <input type="email" className="form-control" defaultValue="test@mail.com" required />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Phone</label>
                          <input type="text" className="form-control" defaultValue="8604613494" required />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label">Amount</label>
                          <input type="text" className="form-control" defaultValue="10.00" required />
                        </div>
                        <div className="col-md-12">
                          <button type="button" className="btn btn-success w-100 mt-3" onClick={handlePayNow}>
                            💳 Pay Now
                          </button>
                        </div>
                      </div>
                    </form>

                    {/* Divider */}
                    <hr className="my-4" />

                    {/* UTR Input */}
                    <div className="form-group">
                      <label>Enter UTR Number (for manual payment)</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="UTR123456..."
                        value={utrNumber}
                        onChange={(e) => setUtrNumber(e.target.value)}
                      />
                      <button className="btn btn-primary mt-3 w-100" onClick={handleSubmit}>
                        📤 Submit UTR
                      </button>
                      {submitMessage && (
                        <div className="mt-2 alert alert-info text-center">{submitMessage}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Qr_Code;
